import { Factory } from "@/data/dao/Factory";
import { RoomDao } from "@/data/dao/service/RoomDao";
import { ServiceType } from "@/data/model/Enums";
import type { IRoomWithService } from "@/data/model/Room";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";

export class RoomTableController {
    private $element: JQuery;
    private dao: RoomDao;

    private dataTable: DataTable<IRoomWithService>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<RoomDao>(RoomDao);

        const tableConfig: IDataTableConfig<IRoomWithService> = {
            columnMapping: [
                {
                    name: i18n("general.fields.name"),
                    property: "name",
                    styles: { width: "20%" },
                },
                {
                    name: i18n("room.fields.endUserServices"),
                    property: "endUserServices",
                    styles: { width: "19%" },
                    sortable: false,
                    formatter: (m) => {
                        if (m.endUserServices.length === 0) {
                            return $(
                                '<a href="/room/' +
                                    m.id +
                                    '#services" style="text-transform:uppercase;">' +
                                    i18n("room.activateService") +
                                    "</a>"
                            ).click((e) => {
                                e.stopPropagation();
                            });
                        } else {
                            let s = "";
                            for (const i in m.endUserServices)
                                s += i18n("enums.ServiceType." + ServiceType[m.endUserServices[i].serviceType]) + ", ";

                            return s.substr(0, s.length - 2);
                        }
                    },
                },
                {
                    name: i18n("room.fields.operatorServices"),
                    property: "operatorServices",
                    styles: { width: "19%" },
                    sortable: false,
                    formatter: (m) => {
                        if (m.operatorServices.length === 0) {
                            return $(
                                '<a href="/room/' +
                                    m.id +
                                    '#services" style="text-transform:uppercase;">' +
                                    i18n("room.activateService") +
                                    "</a>"
                            ).click((e) => {
                                e.stopPropagation();
                            });
                        } else {
                            let s = "";
                            for (const i in m.operatorServices)
                                s += i18n("enums.ServiceType." + ServiceType[m.operatorServices[i].serviceType]) + ", ";

                            return s.substr(0, s.length - 2);
                        }
                    },
                },
                {
                    name: i18n("general.fields.sortOrder"),
                    property: "order",
                    styles: { width: "13%" },
                    formatter: (m, p) => (p === undefined ? i18n("general.alphabeticallyOrdered") : p),
                },
                {
                    name: i18n("room.fields.deallocationDelay"),
                    property: "deallocationDelay",
                    styles: { width: "15%" },
                    formatter: (m, p) => (p === undefined ? "" : p),
                },
                {
                    name: i18n("general.fields.state"),
                    property: "isActive",
                    styles: { width: "8%" },
                    formatter: (m, p) => {
                        return (
                            '<div class="kt-badge ' +
                            (p ? "kt-badge--success" : "kt-badge--danger") +
                            ' kt-badge--inline">' +
                            (p ? i18n("general.fields.active") : i18n("general.fields.inactive")) +
                            "</div>"
                        );
                    },
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            locationDependend: true,
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));

        this.dataTable = new DataTable<IRoomWithService>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/room/" + m.id;
            },
            (m) => {
                window.open("/room/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => this.dataTable.loadData(true), this);
    }
}
